import { permissionsSelector } from '@air/redux-permissions';

import { useAirSelector } from '~/utils/ReduxUtils';

export type UseClipPermissionsParams = {
  clipId: string | undefined;
};

export const useClipPermissions = ({ clipId }: UseClipPermissionsParams) => {
  const clipPermissions = useAirSelector((st) => permissionsSelector(st, 'clipIds', clipId));

  return {
    clipPermissions,
  };
};
